import { inject as service } from '@ember/service';
import DS from 'ember-data';
import Route from 'cio/routes/requires-trigger-type-route';
import CampaignModel from 'cio/models/campaign';
import IndexController from 'cio/pods/base/setup/goal/index/controller';
import Transition from '@ember/routing/-private/transition';
import { ConversionTimeframe, hasEventAttributeComparison } from 'cio/utils/conversions';
import ConfirmChangesService from 'cio/services/confirm-changes';

export default class IndexRoute extends Route {
  templateName = 'base/setup/goal/index';

  @service store!: DS.Store;
  @service confirmChanges!: ConfirmChangesService;

  afterModel() {
    super.afterModel(...arguments);
    return this.store.findAll('short-segment');
  }

  setupController(controller: IndexController, model: CampaignModel, transition: Transition) {
    super.setupController(controller, model, transition);

    // if a conversion is set, and the conversion window is "all time", then we should show the dropdown so they can go
    // go back and forth for backwards compatibility
    if (model.conversion && model.conversionWindow === 0) {
      controller.setProperties({
        allowAnyTimeframe: true,
        selectedTimeframeType: ConversionTimeframe.AnyTime,
      });
    }

    if (model.conversion && model.conversionWindow > controller.maxTimeframe) {
      controller.set('maxTimeframe', model.conversionWindow);
    }

    controller.createGroupCondition(model.conversionEventFilters);

    // if there is a condition using the trigger event we do not need to show banner about data storage
    if (hasEventAttributeComparison(controller.eventConversionCondition)) {
      controller.set('hasAcceptedEventTimeStorageLimit', true);
    }
    this.confirmChanges.register(controller, this);
  }

  deactivate() {
    super.deactivate();

    let controller = this.controllerFor(this.routeName) as IndexController;

    controller.setProperties({
      conversionTracking: false,
      allowAnyTimeframe: false,
      eventConversionCondition: null,
      hasAcceptedEventTimeStorageLimit: false,
      conversionSnapshot: null,
      selectedTimeframeType: ConversionTimeframe.Within,
    });

    this.rollbackModelFor();
  }
}
